import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class DataTableBloc {

    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    detailChannel = new Subject();
    detailChannelDraft = new Subject();
    hirarkiChannel = new Subject();
    createChannel = new Subject();
    selectChannel = new Subject();
    updateChannel = new Subject();
    updateChannelDraft = new Subject();
    eselonChannel = new Subject();
    eselonChannelDraft = new Subject();
    countDraftChannel = new Subject();
    bknServiceOrganisasiChannel = new Subject();

    repository = new IndexRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.activeChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.detailChannelDraft.next({status: apiResponse.INITIAL})
        this.hirarkiChannel.next({status: apiResponse.INITIAL})
        this.createChannel.next({status: apiResponse.INITIAL})
        this.selectChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.updateChannelDraft.next({status: apiResponse.INITIAL})
        this.eselonChannel.next({status: apiResponse.INITIAL})
        this.eselonChannelDraft.next({status: apiResponse.INITIAL})
        this.countDraftChannel.next({status: apiResponse.INITIAL})
        this.bknServiceOrganisasiChannel.next({ status: apiResponse.INITIAL })
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            
        }
    }

    fetchSelect = async (query, cancelToken) => {
        try {
            this.selectChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSelect(query, cancelToken).then((result) => {
                this.selectChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.selectChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            
        }
    }

    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInactive(query).then((result) => {
            this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchActive = async (query) => {
        this.activeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchActive(query).then((result) => {
            this.activeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.activeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchDetailDraft = async (query) => {
        this.detailChannelDraft.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchDetailDraft(query).then((result) => {
                this.detailChannelDraft.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannelDraft.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchHirarki = async (query) => {
        this.hirarkiChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchHirarki(query).then((result) => {
                this.hirarkiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.hirarkiChannel.next({status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchUpdateDraft = async (query) => {
        try {
            this.updateChannelDraft.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdateDraft(query).then((result) => {
                this.updateChannelDraft.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannelDraft.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }


    fetchEselon = async (query) => {
        try {
            this.eselonChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEselon(query).then((result) => {
                this.eselonChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.eselonChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
    fetchEselonDraft = async (query) => {
        try {
            this.eselonChannelDraft.next({status: apiResponse.LOADING})
            await this.repository.fetchEselonDraft(query).then((result) => {
                this.eselonChannelDraft.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.eselonChannelDraft.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchCountDraft = async (query) => {
        try {
            this.countDraftChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCountDraft(query).then((result) => {
                this.countDraftChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.countDraftChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
    bknServiceOrganisasi = async (query) => {
        this.bknServiceOrganisasiChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.bknServiceOrganisasi(query).then((result) => {
                this.bknServiceOrganisasiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.bknServiceOrganisasiChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
}

export default DataTableBloc
